'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z' });

var KeyboardTab = function KeyboardTab(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

KeyboardTab = (0, _pure2.default)(KeyboardTab);
KeyboardTab.muiName = 'SvgIcon';

exports.default = KeyboardTab;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/KeyboardTab.js
// module id = 2525
// module chunks = 0